import { render, staticRenderFns } from "./ProcessedDataList.vue?vue&type=template&id=ab77e1ac&"
import script from "./ProcessedDataList.vue?vue&type=script&lang=js&"
export * from "./ProcessedDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports